import { categoryResource, CategoryResource } from '@witkac/kartamiejska-resources';
import { Category } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 *
 *
 * @export
 * @class CategoriesModule
 * @extends {EntityModule<Category, CategoryResource>}
 */
export class CategoriesModule extends EntityModule<Category, CategoryResource> {
  constructor() {
    super(categoryResource);
    const superList = this.actions.list;
    this.actions = {
      ...this.actions,
      /**
       * Dodaje kategorii
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: (context: any, data: any) => this.resource.add(data),
      /**
       * Aktualizuje kategorii
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: (context: any, data: any) => this.resource.update(data.id, data),

      /**
       * Pobiera listę kategorii
       *
       * @param {*} context
       * @param {*} filters
       */
      list: (context: any, filters: any) => superList(context, { order: 'name', desc: false, ...filters })
    };
  }
}

export default new CategoriesModule();
